export function notEmbeddedInAnIFrame() {
  return window && window.top ? window === window.top : true;
}
